export default __webpack_public_path__ + "static/media/confirmation2.19997238.jpg";